import { getReferenceData } from 'common/reference-data/containers/reference-data-actions';
import { call, fork, put, select, takeLatest } from 'redux-saga/effects';
import callApi from 'utils/api';
import { referenceTypes } from '../../../utils/app-configs';
import * as types from './constants';
import * as actions from './info-actions';

export const getServiceCenterId = state => state.navigation.navigationSelf.serviceCenterId;

export const getAllFunctionalLocationPartnerTypes =
  state => state.referenceData.data[`${getServiceCenterId}_functionallocation_partnerTypes`];
export function* getFunctionalLocationInfo(action) {
  try {
    const results = yield call(callApi, {
      endpoint: `info/functionallocation/${action.payload.id}`,
      options: {
        errorMessage: `Could not get functional location details ${action.payload.id}`,
        retryAction: action,
      },
    });
    const partnerTypes = yield select(getAllFunctionalLocationPartnerTypes);
    const serviceCenterId = yield select(getServiceCenterId);
    if (!partnerTypes || action?.payload?.shouldRefetchPartners) {
      yield put(
        getReferenceData({
          objectType: referenceTypes.functionallocation,
          name: 'partnerTypes',
          urlParams: '',
          serviceCenterId,
        }),
      );
    }
    yield put(actions.getFunctionalLocationInfoSuccess(results));
  } catch (err) {
    yield put(actions.getFunctionalLocationInfoFailure(err));
  }
}

export function* saveFunctionalLocationInfo(action) {
  try {
    const mapping = {
      name: 'name',
      mainWorkCenterName: 'mainWorkCenterName',
      mainWorkCenterNumber: 'mainWorkCenterNumber',
      salesOfficeName: 'salesOfficeName',
      salesOfficeNumber: 'salesOfficeNumber',
      salesGroupName: 'salesGroupName',
      salesGroupNumber: 'salesGroupNumber',
      plannerGroupName: 'plannerGroupName',
      plannerGroupNumber: 'plannerGroupNumber',
      prefWorkCenterName: 'prefWorkCenterName',
      prefWorkCenterNumber: 'prefWorkCenterNumber',
      characteristics: 'characteristics',
      validFromDate: 'validFromDate',
      startUpDate: 'startUpDate',
      acquisitionDate: 'acquisitionDate',
      warrStartDateVendor: 'warrStartDateVendor',
      warrEndDateVendor: 'warrEndDateVendor',
      warrStartDateCustomer: 'warrStartDateCustomer',
      warrEndDateCustomer: 'warrEndDateCustomer',
      statuses: 'statuses',
      countryOfEquipment: 'countryOfEquipmentId',
    };
    const { data, values } = action.payload;
    const request = Object.keys(mapping).reduce(
      (acc, key) => {
        const mappedField = mapping[key];
        if (values[key] && key.includes('Date')) {
          acc[mappedField] = values[key].format('MM/DD/YYYY');
        } else {
          acc[mappedField] = values[key];
        }
        return acc;
      },
      { ...data },
    );
    const results = yield call(callApi, {
      endpoint: `info/update/functionallocation/${data.id}`,
      options: {
        method: 'PUT',
        body: JSON.stringify(request),
        errorMessage: 'Could not update functional location',
        retryAction: action,
      },
    });
    yield put(actions.saveFunctionalLocationInfoSuccess(results));
  } catch (err) {
    yield put(actions.saveFunctionalLocationInfoFailure(err));
  }
}

function* watchGetFunctionalLocationInfo() {
  yield takeLatest(types.GET_FUNCTIONAL_LOCATION_INFO_REQUEST, getFunctionalLocationInfo);
}

function* watchSaveFunctionalLocationInfo() {
  yield takeLatest(types.SAVE_FUNCTIONAL_LOCATION_INFO_REQUEST, saveFunctionalLocationInfo);
}

export default [
  fork(watchGetFunctionalLocationInfo),
  fork(watchSaveFunctionalLocationInfo),
];
